import { render, staticRenderFns } from "./servicios.vue?vue&type=template&id=29bc0506&"
import script from "./servicios.vue?vue&type=script&lang=js&"
export * from "./servicios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports